module.exports = __webpack_public_path__ + "images/emoji/chocolate_bar.e040b7851673f5c4062d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/chocolate_bar.png
// module id = P0MJ
// module chunks = 24